import {
  CartProductItem,
  Dimension,
  getDimensionByUnit,
  getLabelPromptDelivery,
  getLabelResellerPrice,
} from '..'

export const parseOrder = (order: CartProductItem, position?: number) => {
  return {
    name: order.name,
    variant: order.name,
    id: order.id,
    price: order.discountPrice,
    category: order.category,
    brand: order.brand,
    [getDimensionByUnit(Dimension.PROMO_STATUS)]: order.status,
    [getDimensionByUnit(Dimension.PROMPT_DELIVERY)]: getLabelPromptDelivery(
      order.hasPromptDelivery,
    ),
    [getDimensionByUnit(Dimension.RESELLER_PRICE)]: getLabelResellerPrice(order.tags),
    position,
    quantity: order.quantity,
  }
}
